<template>
    <v-layout v-if="store.state.user.token&&groupe.find(g=>g==store.state.user.groupe)">
        <v-table>
            <tbody>
                <tr>
                    <td>
                        <v-navigation-drawer>
                            <v-card>
                                <v-overlay v-model="store.state.waiting"></v-overlay>
                                <v-list-item title="Liste de réceptions" subtitle="Vuetify"></v-list-item>
                                <v-row >
                                    <v-checkbox label="Encours" v-model="inProgress" @change="finished=false;getReceptions()" style="margin-left: 1em;"></v-checkbox>
                                    <v-checkbox label="Terminé" v-model="finished" @change="inProgress=false;accepted=false;denied=false;getReceptions()"></v-checkbox> 
                                </v-row>
                                 <v-row style="margin-top: -30px;" v-if="inProgress">
                                    <v-checkbox label="ATT" v-model="attente" @change="finished=false;accepted=false;denied=false;getReceptions();" style="margin-left: 1em;"></v-checkbox> 
                                    <v-checkbox label="OK" v-model="accepted" @change="finished=false;attente=false;denied=false;getReceptions()"></v-checkbox>
                                    <v-checkbox label="KO" v-model="denied" @change="finished=false;attente=false;accepted=false;getReceptions()"></v-checkbox> 
                                </v-row> 
                                <v-row style="margin-top: -30px;">
                                    <v-text-field
                                        v-model="rechercher"
                                        label="Rechercher"
                                        variant="outlined" 
                                        density="compact"
                                        style="margin: 20px;"
                                    ></v-text-field>
                                </v-row>
                                <v-row style="margin-top: -40px;">
                                    <v-col>
                                        <v-btn style="display: block;margin-right: auto;margin-left: 50px;" @click="exportToExcel()"   color="success" >
                                            <v-icon icon="mdi-file-excel"></v-icon>
                                        </v-btn> 
                                    </v-col>
                                    <v-col>
                                        <v-btn 
                                            @click.stop="dialogStatsTiers=true"
                                            variant="tonal"
                                            size="small"
                                            class="mr-2"
                                            icon="mdi-google-analytics"
                                            >
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                
                                
                                <v-list>
                                    <v-divider></v-divider>
                                    <v-list-item 
                                        v-for="(item, i) in listeReceptions"
                                        :key="i"
                                        :value="item"
                                        color="primary"
                                        variant="plain"
                                        @click="getReception(item,i);selected=true"
                                    >
                                    <button type="button" class="btn btn-outline-secondary btn-sm" style="width: 200px;">
                                        <span>{{ item.title}}</span><br>
                                        <span v-if="item.reception.informations" :style="[(item.reception.informations.match(/ref/gmi)||item.reception.etat.match(/ref/gmi))?{'color':'red'}:{'color':'green'}]">
                                            {{ `${item.reception.informations?''+item.reception.informations:''}`}}
                                        </span> 
                                    </button>
                                </v-list-item>
                                </v-list>
                            </v-card> 
                        </v-navigation-drawer>
                    </td>
                    <td  >
                        <v-main  >
                            <div class="container" style="margin-top: 50px;min-width: 1200px;" >
                                
                            
                            <v-expansion-panels
                            v-model="panel"
                            :disabled="disabled"
                            multiple
                            >
                                <v-expansion-panel >
                                    <v-expansion-panel-title color="primary">
                                        <template v-slot:actions="{ expanded }">
                                            <v-icon :icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"></v-icon>
                                        </template>
                                        
                                        <!-- Contenu du titre -->
                                        <span>Réception</span>
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text v-if="selected">
                                        <div v-if="selected">
                                            <v-row >
                                                <v-col cols="12"  md="1">
                                                    <v-text-field  v-model="reception.etablissement" label="Magasin" readonly variant="outlined" density="compact"></v-text-field> 
                                                </v-col> 
                                                <v-col cols="12"  md="1">
                                                    <v-text-field v-model="reception.numeroBon" label="Numéro" readonly variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                <v-col cols="12"  md="2">
                                                    <v-text-field  v-model="reception.date.split('T')[0]" label="Date" readonly variant="outlined" density="compact"></v-text-field> 
                                                </v-col> 
                                                <v-col cols="12" md="2">
                                                    <v-text-field  v-model="reception.vendeur" label="Vendeuse/Vendeur" readonly variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                <v-col cols="12" md="3">
                                                    <v-combobox  v-model="reception.etat" label="Status" :items="itemsStatus" :disabled="reception&&termine" variant="outlined" density="compact"></v-combobox>
                                                </v-col> 
                                                <v-col cols="12"  md="3">
                                                    <v-text-field v-model="reception.informations" label="Motif" :disabled="reception&&termine"
                                                    :style="[reception&&reception.etat.match(/refus|valid/gmi)?(reception.informations&&reception.informations!=''?{color:'green'}:{color:'red'}):{}]"
                                                     variant="outlined" density="compact"
                                                    
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row style="margin-top: -30px;">
                                                <v-col cols="12" md="1">
                                                    <v-text-field  v-model="reception.ticket" label="Ticket?" readonly variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                <v-col cols="12" md="2">
                                                    <v-text-field  v-model="reception.bonAchat" label="Bon Achat" readonly variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                <v-col cols="12" md="2">
                                                    <v-text-field  v-model="reception.choixReprise" label="Choix Reprise" readonly variant="outlined" density="compact"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="2">
                                                    <v-combobox v-model="reception.language" label="Langue"  
                                                    :items="['fr','nl']" 
                                                    variant="outlined" density="compact" 
                                                    ></v-combobox>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        
                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                                <v-expansion-panel>
                                    <v-expansion-panel-title color="primary">Articles</v-expansion-panel-title>
                                    <v-expansion-panel-text v-if="selected">
                                        <div v-if="selected" v-for="item in articles" :key="item">
                                             <v-row>
                                                <v-col cols="12"  md="2">
                                                    <v-text-field  v-model="item.marque" label="Marque" readonly variant="outlined" density="compact"></v-text-field> 
                                                </v-col> 
                                                <v-col cols="12"  md="2">
                                                    <v-combobox  v-model="item.grade" label="Grade" :items="itemsGrade"  variant="outlined" density="compact"
                                                     @update:model-value="modifier(item.grade.libelle,title,item.id,'grade')"
                                                     item-title="libelle"  item-value="libelle"></v-combobox>
                                                </v-col> 
                                                <v-col cols="12"  md="2">
                                                    <v-text-field  v-model="compositionLib" label="Composition" readonly variant="outlined" density="compact"></v-text-field> 
                                                </v-col> 
                                                 
                                                <v-col cols="12" md="2">
                                                    <v-text-field v-model="item.sousFamille" label="Sous Famille" readonly variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                <v-col cols="12"  md="2">
                                                    <v-text-field v-model="item.libCouleur" label="Couleur" readonly variant="outlined" density="compact"></v-text-field>
                                                </v-col>
                                                <v-col cols="12"  md="1">
                                                    <v-text-field v-model="item.qteCommande" label="Qté"  readonly
                                                     variant="outlined" density="compact"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row style="margin-top: -30px;">
                                                <v-col cols="12" md="2">
                                                    <v-text-field  v-model="formattedPrixPublicTTC"
                                                    type="number"
                                                    label="Prix TTC"  variant="outlined" density="compact" prefix="€"
                                                    @change="modifier($event.target.value,title,item.id,'prixPublicTTC')"
                                                    :style="[formattedPrixPublicTTC==0?{'color':'red'}:{'color':'green'}]"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12"  md="2">
                                                    <v-text-field v-model="formattedPrixAchatHT"  
                                                    type="number"
                                                    
                                                    label="Prix Reprise"  variant="outlined" density="compact" prefix="€"
                                                    @change="modifier($event.target.value,title,item.id,'prixAchatHT')"
                                                    :style="[formattedPrixAchatHT==0?{'color':'red'}:{'color':'green'}]"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12"  md="2">
                                                    <v-text-field v-model="formattedPrixAchatOrigine" 
                                                    type="number"
                                                    label="Prix Origine Achat"  variant="outlined" density="compact" prefix="€"
                                                    @change="modifier($event.target.value,title,item.id,'prixAchatOrigine')"></v-text-field>
                                                </v-col>
                                                
                                                <v-col cols="6"  md="6">
                                                    <v-text-field v-model="item.remarque" label="Remarque"  readonly
                                                     variant="outlined" density="compact"
                                                      
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </div>
                                       
                                        <!-- <div > -->
                                            <v-row style="margin-top: -30px;" v-if="photos.photos">
                                                <v-col cols="12"   md="1"  sm="6">
                                                    <button  @click="indexPhoto.type='signature';getPhotos(`signature_${reception.etablissement}-${reception.numeroBon}.png`)" type="button" class="btn btn-outline-secondary btn-sm">Signature</button>
                                                </v-col>
                                                
                                                <v-col cols="12"  md="1" v-for="(el, index) in photos.photos"  sm="6">
                                                    <button v-if="el!=''"  @click="getPhotos(el);indexPhoto.type='photo';indexPhoto.index=index" type="button" class="btn btn-outline-secondary btn-sm">Photo {{ index }}</button>
                                                </v-col>
                                            </v-row>
                                            
                                    </v-expansion-panel-text>
                                </v-expansion-panel>

                                <v-expansion-panel>
                                    <v-expansion-panel-title color="primary">
                                        <template v-slot:actions="{ expanded }">
                                            <v-icon :icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"></v-icon>
                                        </template>
                                        
                                        <!-- Contenu du titre -->
                                        <span>Client</span> 
                                        <v-chip
                                        :style="[emailStatus.status?{'color':'white'}:{'color':'orange'}]"
                                        
                                        size="small"
                                        class="ml-2"
                                        >
                                        {{ emailStatus.message }}
                                        </v-chip>
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text v-if="selected">
                                            <v-row>
                                                
                                                
                                            </v-row>
                                            <v-row >
                                                <v-col  cols="12" md="2">
                                                    <v-text-field  v-model="bonReception.client.firstname" label="Prénom" readonly variant="outlined" density="compact"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" md="2" >
                                                    <v-text-field v-model="bonReception.client.lastname" label="Nom" readonly variant="outlined" density="compact"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" md="2">
                                                    <v-text-field v-model="bonReception.client.birdhDay" type="date" label="Date de naissance" readonly variant="outlined" density="compact"
                                                    ></v-text-field>
                                                </v-col>

                                                <v-col cols="12"  md="2">
                                                    <v-text-field v-model="bonReception.client.telephone" label="Téléphone" readonly variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                <v-col cols="12" md="3">
                                                    <v-text-field v-model="bonReception.client.email" label="E-mail" variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                <v-col  cols="12" md="1">
                                                    <v-text-field  v-model="bonReception.client.sexe" label="Sexe" readonly variant="outlined" density="compact"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row style="margin-top: -30px;">
                                                <v-col cols="12"  md="2">
                                                    <v-text-field v-model="bonReception.client.pays" label="Pays" readonly variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                <v-col cols="12"  md="2">
                                                    <v-text-field v-model="bonReception.client.codePostal" label="Code Postal" readonly variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                <v-col cols="12" md="2">
                                                    <v-text-field v-model="bonReception.client.ville" label="Ville" readonly variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                <v-col cols="12"  md="6">
                                                    <v-text-field v-model="bonReception.client.adresse" label="Adresse" readonly variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                            </v-row>
                                            <!-- <v-row style="margin-top: -30px;">
                                                
                                            </v-row> -->
                                    </v-expansion-panel-text>
                                </v-expansion-panel>

                                <v-expansion-panel>
                                    <v-expansion-panel-title color="primary">Emailing</v-expansion-panel-title>
                                    <v-expansion-panel-text v-if="selected">
                                            <v-row>
                                                <v-col cols="12" md="3">
                                                    <v-text-field v-model="reception.email" label="E-mail" variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                <v-col cols="12" md="2">
                                                    <v-text-field v-model="reception.prenom" label="Prénom" variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                
                                                <v-col cols="12" md="1">
                                                    <v-btn :text="reception.etat.match(/(proposition|relance)/gmi)?'Relancer':'E-mail'" :color="reception.etat.match(/(proposition|relance)/gmi)?'warning':'success'" @click="reSendEmail()"></v-btn>
                                                </v-col> 
                                            </v-row>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>

                            </v-expansion-panels>
                            <v-dialog  width="500">
                                <template v-slot:activator="{ props: activatorProps }">
                                    <v-btn v-if="reception"
                                    v-bind="activatorProps"
                                    :color="termine?'danger':'success'"
                                    :text="termine?'Débloquer':'Valider'"
                                    variant="flat"
                                    :disabled="etat()"
                                    block
                                    ></v-btn>
                                </template>

                                <template v-slot:default="{ isActive }">
                                    <v-card :title="termine?'Déblocage':'Validation'">
                                    <v-card-text>
                                       {{ termine?'Vous voulez vraiment Débloquer la reprise?':'Vous voulez vraiment valider la reprise?' }} 
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <input :rules="rules(mdpSaisie)" :style="[mdpSaisie==mdp?{'color':'green'}:{'background-color':'pink','color':'red'}]"
                                        type="text" class="form-control" placeholder="mot de passe" aria-label="mot de passe" aria-describedby="basic-addon2" v-model="mdpSaisie">
                                        <v-btn
                                        text="Annuler"
                                        @click="isActive.value = false"
                                        color="warning"
                                        ></v-btn>
                                        <v-btn
                                        :text="termine?'Débloquer':'Terminer'"
                                        @click="isActive.value = false;validerReception(termine?true:false)"
                                        :disabled="mdpSaisie===mdp?false:true"
                                        :color="termine?'danger':'success'"
                                        ></v-btn>
                                    </v-card-actions>
                                    </v-card>
                                </template>
                            </v-dialog>
                            <div class="text-center pa-4">

                                <v-dialog
                                    v-model="dialogEmail"
                                    width="auto"
                                >
                                    <v-card
                                    max-width="400"
                                    prepend-icon="mdi-update"
                                    :text="`Le dernier email a été renvoyé`"
                                    title="Email envoyé"
                                    >
                                    <template v-slot:actions>
                                        <v-btn
                                        class="ms-auto"
                                        text="Ok"
                                        @click="dialogEmail = false"
                                        ></v-btn>
                                    </template>
                                    </v-card>
                                </v-dialog>
                            </div>
                        </div>
                        </v-main>

                    </td>
                </tr>
            </tbody>
        </v-table>
    </v-layout>
    <div >
      <v-dialog v-model="imageDialog" width="600px">
        <v-card width="600px">
            <!-- <v-card-text style="margin: -10px;"> -->
                <v-sheet
                    :elevation="10"
                    style="margin: 10px;"
                    
                >
                    <v-img
                        class="align-end text-white"
                        
                        :src="srcImage"
                        cover
                    >
                    <v-card-title v-if="!indexPhoto.type.match(/signature/gmi)">
                        {{ `Photo ${indexPhoto.index}` }}
                        </v-card-title>
                    <v-card-title v-if="indexPhoto.type.match(/signature/gmi)" style="color: black;" class="font-italic font-weight-bold text-h6">{{ `Signature` }}</v-card-title>
                    </v-img>
                </v-sheet>
                
                <!-- <v-img
                    width="600"
                    cover
                    :src="srcImage"
                ></v-img> -->
            <!-- </v-card-text> -->
            <!-- <v-divider ></v-divider> -->
            <v-card-actions class="my-2 d-flex justify-space-between">
                <v-btn
                  class="text-none"
                  rounded="xl"
                  text="Précédent"
                  @click="indexPhoto.type='photo';(indexPhoto.index<=1?(indexPhoto.index=photos.photos.length-1):indexPhoto.index--);getPhotos(photos.photos[indexPhoto.index])"
                  color="primary"
                ></v-btn>
                <v-btn
                  class="text-none"
                  rounded="xl"
                  text="Fermer"
                  color="danger"
                  @click="imageDialog=false"
                ></v-btn>
                <v-btn
                  class="text-none"
                  color="primary"
                  rounded="xl"
                  text="Suivant"
                  
                  @click="indexPhoto.type='photo';(indexPhoto.index>photos.photos.length-2?(indexPhoto.index=1):indexPhoto.index++);getPhotos(photos.photos[indexPhoto.index])"
                ></v-btn>
                <!-- variant="flat" -->
              </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
     <v-dialog
        v-model="dialogStatsTiers"
        width="auto"
        persistent
    >
        <v-card
        prepend-icon="'mdi-google-analytics"
        title="Statistiques Second Life"
        >
        <v-card-text>
            <div width="900px">
                <table>
                    <tbody>
                        <tr>
                            <!-- <v-btn density="compact" @click="statsToGet='all';dialogueFiltre=true" icon="mdi-plus" style="margin-top: 15px;" ></v-btn> -->
                            <td width="150px">
                                <v-select  
                                variant="outlined"
                                :items="['etablissement','marque','code_sousfamille','designation','code_famille','famille','couleur','statut','grade','annee','mois','mois_annee']"
                                density="compact"
                                label="Axe X"
                                v-model="axe.x"
                                ></v-select>
                            </td>
                            <td width="150px" style="margin-left: 10px;">
                                <v-select
                                    variant="outlined"
                                    :items="['achat_euro','vte_euro','qte']"
                                    density="compact"
                                    label="Axe Y"
                                    v-model="axe.y"
                                ></v-select>
                            </td>
                            <td width="70px">
                                <v-switch  v-model="isBarChart" :label="isBarChart ? '📊' : '🥧'"></v-switch>
                            </td>
                            <td width="70px">
                                <v-switch  v-model="axe.showPercent" :label="axe.showPercent ? '%' : '€'"></v-switch>
                            </td>
                            <!-- <td width="160px" style="margin-left: 10px;"> 
                                <v-text-field :disabled="authorized.modif" density="compact" v-model="filtreSingleParams.gp_tiers" label="Code Client" type="text" variant="outlined" clearable></v-text-field>
                            </td>
                            <td width="160px" style="margin-left:10px;">
                                <v-combobox clearable    chips    multiple
                                    label="Saison"
                                    :items="['SAIH22','SAIH23','SAIH24','SAIH25','SAIH26','SAIE22','SAIE23','SAIE24','SAIE25','SAIE26']"
                                    v-model="filtreSingleParams.gp_librepiece3"
                                    variant="outlined" density="compact"
                                ></v-combobox>
                            </td> -->
                            <!-- <v-btn style="margin-top: 15px;margin-left: 10px;"
                                density="compact"
                                :loading="loading"
                                :disabled="!filtreSingleParams.gp_tiers&&!filtreSingleParams.gp_librepiece3"
                                @click="loading=true;dialogErreur=false;getStatsTiers('rechercherNegoces',filtreSingleParams.gp_tiers)"
                                aria-label="Refresh"
                                icon="mdi-refresh"
                            ></v-btn>
                            <v-btn  density="compact" style="margin-top: 15px;;margin-left: 10px;" color="green" @click="exportToExcel(statsTable)" >
                                <v-icon icon="mdi-file-excel"></v-icon>
                            </v-btn> -->
                        </tr>
                    </tbody>
                </table>
            </div>
            <div   class="chart-chart-container-pie">
                <div style="height: 400px">
                    <Pie  v-if="!isBarChart" :data="chartDataStats" :options="pieOptions" />
                    <Bar  v-if="isBarChart" :data="chartDataStats" :options="barOptions" />
                </div>
            </div>
        </v-card-text>
            <template v-slot:actions>
                <v-btn
                class="ms-auto"
                text="Ok"
                @click="dialogStatsTiers = false"
                ></v-btn>
            </template>
        </v-card>
    </v-dialog>
</template>
<script setup>
import { ref,watch } from 'vue';
import store from './store';
import { onMounted, computed } from 'vue';
import axios from 'axios';
import * as XLSX from 'xlsx';
import {
    Chart as ChartJS,
        Title,
        Tooltip,
        Legend,
        ArcElement,
        BarElement,
        CategoryScale,
        LinearScale 
    } from 'chart.js'
    import { Pie, Bar } from 'vue-chartjs'

let rechercher=ref()
let listeReceptions=ref(store.state.listeReceptions.receptions.sort((a,b)=>{return b.reception.numeroBon-a.reception.numeroBon}))

let formattedPrixPublicTTC=computed({
 get: () => {
    return articles.value[0].prixPublicTTC === null || articles.value[0].prixPublicTTC == 0 
      ? '' 
      : articles.value[0].prixPublicTTC;
  },
  set: (value) => {
    const finalValue = value === '' ? null : value;
    articles.value[0].prixPublicTTC = finalValue;
    // Appeler votre fonction modifier ici
    modifier(finalValue, title, articles.value[0].id, 'prixPublicTTC');
  }
})
let formattedPrixAchatHT=computed({
 get: () => {
    return articles.value[0].prixAchatHT === null || articles.value[0].prixAchatHT == 0 
      ? '' 
      : articles.value[0].prixAchatHT;
  },
  set: (value) => {
    const finalValue = value === '' ? null : value;
    articles.value[0].prixAchatHT = finalValue;
    // Appeler votre fonction modifier ici
    modifier(finalValue, title, articles.value[0].id, 'prixAchatHT');
  }
})
let formattedPrixAchatOrigine=computed({
  get: () => {
    return articles.value[0].prixAchatOrigine === null || articles.value[0].prixAchatOrigine == 0 
      ? '' 
      : articles.value[0].prixAchatOrigine;
  },
  set: (value) => {
    const finalValue = value === '' ? null : value;
    articles.value[0].prixAchatOrigine = finalValue;
    // Appeler votre fonction modifier ici
    modifier(finalValue, title, articles.value[0].id, 'prixAchatOrigine');
  }
})
let compositionLib=computed(()=>{
    let compo=''
    switch (articles.value[0].composition) {
        case '03': compo='Cuir'
            
            break;
        case '06': compo='Synthétique'
            
            break;
        case '44': compo='Textile'
            
            break;
        default:
            break; compo='Cuir'
    }
    return compo
})
watch(rechercher,()=>{
    let regex = new RegExp(rechercher.value, "i")
     listeReceptions.value=store.state.listeReceptions.receptions.filter(el=>(`${el.title}${el.reception.informations?'-'+el.reception.informations+'-'+el.articles[0].cab+'-'+el.articles[0].id:''}${el.reception.bonAchat?'-'+el.reception.bonAchat:''}`).match(regex)).sort((a,b)=>{return b.reception.numeroBon-a.reception.numeroBon})
})
const modifier=(value,title,id,champs)=>{
    store.commit('editRowArticleReception',{'value':value,'title':title,'id':id,'champs':champs})
}
let etat=()=>{
    return (reception.value&&(reception.value.etat.match(/cours/gmi)
    || (articles.value[0].prixAchatHT==0&&!reception.value.etat.match(/refus/gmi))
    || (reception.value.etat.match(/proposition/gmi)&&articles.value[0].prixAchatHT==0)
    // || (reception.value.etat.match(/valid/gmi)&&reception.value.ticket.match(/non/gmi))
    || (!reception.value.etat.match(/REFUS_CLIENT/gmi)&&reception.value.etat.match(/refus/gmi)&&(reception.value.informations==''||reception.value.informations==null))
    || (!reception.value.etat.match(/ACCEPT_CLIENT/gmi)&&reception.value.etat.match(/valid/gmi)&&(reception.value.informations==''||reception.value.informations==null))))
    ?true:false
}
let indexPhoto=ref({
    type:'photo',
    index:1
})
let dialogEmail=ref(false)
let groupe=ref(['A','B'])
let panel=ref( [0, 1])
let itemtoDelete=ref()
let imageDialog=ref(false)
let srcImage=ref()
let itemsGrade=ref([
    {code:'A',libelle:'A-Excellent état'},
    {code:'A',libelle:'B-Très bon état'},
    {code:'C',libelle:'C-Bon état'}])
let articles=ref()
let itemsStatus=ref(['En cours','Refusé','Validé','Proposition'])
let bonReception=ref()
let title=ref()
let mdpSaisie=ref()
let dialogStatsTiers=ref(false)
let axe=ref({
        x:'etablissement',
        y:'qte',
        showPercent:false
    })
const isBarChart = ref(false)
let headers=ref([
    { key: 'marque',title: 'Marque'},
    // { key: 'theme', title: 'Thème' },
    { key: 'grade', title: 'Grade' },
    // { key: 'refFourn', title: 'Ref_fourn' },
    { key: 'composition', title: 'Composition' },
    { key: 'prixPublicTTC', title: 'Prix_TTC' },
    { key: 'sousFamille', title: 'Sous_Famille' },
    { key: 'libCouleur', title: 'Couleur' },
    { key: 'prixAchatHT', title: 'Prix_Reprise' },
    { key: 'prixAchatOrigine', title: 'Prix_Origine' },
    { key: 'qteCommande', title: 'Qte' },
    { key: 'accessoires', title: 'Acessoires' },
    // { key: 'poidnet', title: 'PoidsNet' },
    // { key: 'dimensions', title: 'Dimensions_L*H*P' },
    { key: 'remarque', title: 'Remarque_acheteur' }
    // ,
    // { key: 'totalBrut', title: 'Total_Brut' } 
    ]) 
let photos=ref()
const supprimer=(item)=>{
    itemtoDelete=item
}
let inProgress=ref(false)
let finished=ref(false)
let accepted=ref(false)
let attente=ref(false)
let denied=ref(false)
let reception=ref()
let checked=ref(true)
let disabled=ref(false)
let deleteDialog=ref(false)
let selected=ref(false)
let photo=ref()
let termine=ref()
const mdp=ref('fripe')

const sum=(object,value)=>{
    let sum=0
    for(let key in object){
        sum=sum+(object[key][value]?Number(object[key][value]):0)
    } 
    return sum
    } 
let rules=(value)=>{
    if (value===mdp.value){
        return [true]
      } else{
        return [`Mot de passe n'est pas correcte`]
      }
  }
const getReception=(item,i)=>{
    // console.log(item);
    
    photo.value=''
    bonReception.value=item
    articles.value=bonReception.value.articles
    reception.value=bonReception.value.reception
    photos.value=bonReception.value.photos
    termine.value = bonReception.value.termine === 'true' || bonReception.value.termine === true
    title.value=bonReception.value.title   
    verifierEmail(reception.value.email)
}
async function getReceptions(){  
    store.commit('updateWaiting')  
    let url=    `https://my.edisac.com/api/receptions`
    let config = {
    method: 'get',
    url: url,
    params:{finished:finished.value,inprogress:inProgress.value,attente:attente.value,accepted:accepted.value,denied:denied.value}
    };
    return   axios.request(config)
    .then((response) => {
        store.commit('addListeReceptions',response.data)
        statsTable.value=response.data
        statsTableFiltred.value=response.data
        listeReceptions.value=store.state.listeReceptions.receptions.sort((a,b)=>{return b.reception.numeroBon-a.reception.numeroBon})
        store.commit('updateWaiting')  
    })
    .catch((error) => {
    //console.log(error);
    });
}
let emailStatus=ref({
    email:'',
    status:true,
    message:'Email Validé'
})
async function verifierEmail(email) {
    let data={
        email:encodeURIComponent(email.trim())
    }
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/verify-email',
    headers: { 
        'Content-Type': 'application/json'
    },
    data : data
    
    
    };

    axios.request(config)
    .then((response) => {
        if(response.data.isValid){
            
            emailStatus.value= {
                email:email,
                status:true,
                message:'Email Validé'
            }
        }else{
            emailStatus.value= {
                email:email,
                status:false,
                message:'L’adresse e-mail n’existe pas'
            }
        }
    })
    .catch((error) => {
    // console.log(error);
    });
}
const chartDataStats = computed(() => {
            const data = chartData2()
            return {
                labels: data.tabTheme,
                datasets: [{
                label: `Données ${axe.value.showPercent?'% ':''}`,
                data: data.tabQte,
                backgroundColor: data.colorTab
                }]
            }
        })

    ChartJS.register(
        Title,
        Tooltip,
        Legend,
        ArcElement,
        BarElement,
        CategoryScale,
        LinearScale
    )

    const pieOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: 'right' }
        }
    }

    const barOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: { beginAtZero: true }
        }
    }
    let statsTable=ref([])
    let statsTableFiltred=ref([])
    function chartData2() {
        const qte = { autre: 0 };
        const colorTab = [generateRandomColor()];
        let sum = 0;
        
        const data = statsTableFiltred.value.data.map(el=>el={...el,annee:(new Date(el.date)).getFullYear(),mois:(new Date(el.date)).toLocaleString('fr-FR', { month: 'long' }),mois_annee:`${(new Date(el.date)).toLocaleString('fr-FR', { month: 'long' })}_${(new Date(el.date)).getFullYear()}`});
        
        
        // Traitement unique
        Object.values(data).forEach(item => {
            if (!item || item[axe.value.x] === undefined) return;
            if(item[axe.value.x] ){
                const xVal = item[axe.value.x].toString();
                const yVal = Number(item[axe.value.y]) || 0;
                
                if (!xVal) {
                    qte.autre += yVal;
                } else {
                    if (!qte[xVal]) {
                        colorTab.push(generateRandomColor());
                        qte[xVal] = yVal;
                    } else {
                        qte[xVal] += yVal;
                    }
                }
                sum += yVal;
            }
            
        });
        
        // Nettoyage et retour
        if (qte.autre === 0) {
            delete qte.autre;
            colorTab.shift();
        }
        
        const tabTheme = Object.keys(qte);
        let tabQte = Object.values(qte);
        
        if (axe.value.showPercent) {
            const factor = 100 / sum;
            tabQte = tabQte.map(value => value * factor);
        }
        // console.log({ tabTheme, colorTab, tabQte });
        
        return { tabTheme, colorTab, tabQte };
        
        // function getDataSource() {
        //     return grapheType.value === 'tiers' 
        //         ? tiersTable.value
        //         : axe.value.source === 'GLOBAL'
        //             ? statsTable.value
        //             : statsTableFiltred.value;
        // }
        
        function generateRandomColor() {
            return '#' + ((Math.random() * 0xFFFFFF) << 0).toString(16).padStart(6, '0');
        }
    } 
    
    watch(
        axe,
        (newValue, oldValue) => {
            chartData2()
        },
        { deep: true } // Important pour surveiller les changements dans l'objet
    )
async  function getPhotos (el){
    let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/getphoto',
    headers: { 
        'Content-Type': 'application/json'
    },
    params : {photo:el}
    }

    return axios.request(config)
    .then((response) => { 
        srcImage.value=response.data
        imageDialog.value=true;
        
    })
    .catch((error) => {
    //console.log(error);
    });
}

async  function validerReception(debloquer){

    termine.value=termine.value?false:true
    let data = {...bonReception.value,termine:true,debloquer:debloquer}
    store.commit('terminerReception',data)   
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/recordsfripe',
    headers: { 
        'Content-Type': 'application/json'
    },
    data : data
    }
    return axios.request(config)
    .then((response) => {    
    })
    .catch((error) => {
    //console.log(error);
    });
 }
 async function reSendEmail(){
    dialogEmail.value=true
    
    let data = {...bonReception.value,attente:attente.value}
        
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/resendemail',
    headers: { 
        'Content-Type': 'application/json'
    },
    data : data
    }

    return axios.request(config)
    .then((response) => { 
        
    })
    .catch((error) => {
    //console.log(error);
    });
}
const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(store.state.listeReceptions.data.map(el=>el={...el,annee:(new Date(el.date)).getFullYear(),mois:(new Date(el.date)).toLocaleString('fr-FR', { month: 'long' }),mois_annee:`${(new Date(el.date)).toLocaleString('fr-FR', { month: 'long' })}_${(new Date(el.date)).getFullYear()}`}));
    
    
    const workbook = XLSX.utils.book_new();
    
    XLSX.utils.book_append_sheet(workbook, worksheet, `EXPORT_FRIPE_`);

    // Télécharger le fichier
    XLSX.writeFile(workbook, `export_secondLife_${getCurrentDateYYYYMMDD()}.xlsx`);
};
function getCurrentDateYYYYMMDD() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Mois commence à 0
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}${month}${day}`;
}


onMounted(()=>{
    getReceptions()
})


</script>
<style scoped> 
.photo {
    color:blue;
    cursor: pointer;
}
.photo:hover{
    background-color: lightgrey
}
.adaptive-text {
  /* Le navigateur choisit automatiquement blanc ou noir */
  color: contrast(100%);
  font-family: 'Great Vibes', 'Dancing Script', cursive;
  font-size: 1.8rem;
  padding: 8px;
  display: inline-block;
}
</style>
